import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import Tooltip from "@mui/material/Tooltip";
import toast, { Toaster } from "react-hot-toast";
import { jsPDF } from "jspdf";
import { useNavigate, Link, useParams } from "react-router-dom";
import {
    getSalesOrderDetail,
    getSalesOrderList,
    logSalesOrderHistory,
} from "../../../services/index";
import ViewPdf from "../../Common/ViewPdf";
import AddIcon from "@mui/icons-material/Add";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EditIcon from "@mui/icons-material/Edit";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { getFormattedNumber, searchForMatch } from "../../utils/textUtils";
import Loader from "../../Common/Loader";
import { Shop2Outlined } from "@mui/icons-material";
import { Button } from "react-bootstrap";
import { multipleSalesOrder } from "../../../services/Sales/SalesOrderService";
import { FaTruckPickup } from "react-icons/fa";

const SalesView = (props) => {
    let { id } = useParams();
    const [tabIndex, setTabIndex] = useState(0);

    const [pdfOption, setPdfOption] = useState("");
    const [keys, setKeys] = useState("");
    const [values, setValues] = useState("");

    const [hsnKey, setHsnKey] = useState("");
    const [hsnVal1, setHsnVal1] = useState("");
    const [hsnVal2, setHsnVal2] = useState("");
    const [pick, setPick] = useState(false)
    const [taxType, setTaxType] = useState("");
    const [orgDetail, setOrgDetail] = useState("");
    const [logData, setLogData] = useState({});
    const [salesOrdersList, setSalesOrdersList] = useState([]);
    const [salesOrderDetail, setSalesOrderDetail] = useState(null);
    const [batchDetails, setBatchDetails] = useState([])
    const [index, setIndex] = useState(0);
    const [salesOrderListDetails, setSalesOrderListDetails] = useState(null);
    const [filterText, setFilterText] = useState("");
    const [picklist, setPickList] = useState([])
    let org = JSON.parse(localStorage.getItem("orgDetail"));
    let orgState = org?.beanAddress?.state;
    const [multiBatch, setmultiBatch] = useState([])


    let navigate = useNavigate();

    const handleEdit = (orderUuid) => {
        navigate("/salesorders/" + orderUuid + "/edit");
    };

    const [rows, setRows] = useState([]);
    const getAllSalesOrders = () => {
        let list_data = {
            page: index,
            size: 15,
            search: filterText,
        };
        getSalesOrderList(list_data).then((res) => {
            if (res.errorCode === 0) {
                // res.responsePacket.data.reverse();
                if (index === 0) {
                    setSalesOrdersList(res.responsePacket.data);
                    setRows(res.responsePacket.data);
                } else {
                    const salesOrdersListClone = [...salesOrdersList, ...res.responsePacket.data];
                    setSalesOrdersList(salesOrdersListClone);
                    setRows(salesOrdersListClone);
                }
                setIndex(index + 1);
                setSalesOrderListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })
            } else {
                toast(res.message);
            }
        });
    };

    const getSalesOrderDetails = (id) => {
        getSalesOrderDetail(id).then((res) => {
            if (res.errorCode === 0) {
                let ddd = res.responsePacket;
                let d = res.responsePacket.items;

                ddd.customerAddresses.map((a) => {
                    if (a.addressType === "Billing") {
                        ddd.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        ddd.shipAdd = a;
                    }
                });

                var tot = JSON.parse(JSON.stringify(ddd.totalAmount));
                let tot1 = 0;
                let finalTotal = 0;
                let netTax = 0;
                let disTax = 0;
                let disPercent = 0;
                let disAmount = 0;
                let disSubtotal = 0;

                let sub1 = 0;
                d?.map((a) => {
                    sub1 = sub1 + a.amount;
                });
                if (
                    Number(sub1).toFixed(2) !==
                    Number(ddd.subTotalAmount).toFixed(2)
                ) {
                    toast.error("subtotal mismatch");
                }

                var subtot = JSON.parse(
                    JSON.stringify(res.responsePacket.subTotalAmount)
                );

                // Discount already applied in rate by backend
                ddd.discountSubTotal = subtot;
                ddd.discountPercent = 0;
                ddd.discountAmount = 0;

                d.map((a) => {
                    a.taxBean.newTax =
                        a.taxBean.taxType + a.taxBean.rate.toString();
                    a.taxBean.disAmount = a.taxBean.amount;
                    a.disItemAmount = a.amount;
                    netTax += a.taxBean.amount;
                    disTax += a.taxBean.disAmount;
                    disSubtotal += a.taxBean.disItemAmount;
                });

                let obj = {};
                for (let i = 0; i < d.length; i++) {
                    if (obj[d[i].taxBean.newTax]) {
                        obj[d[i].taxBean.newTax] += d[i].taxBean.disAmount;
                    } else {
                        obj[d[i].taxBean.newTax] = d[i].taxBean.disAmount;
                    }
                }
                let s1 = ddd?.shippingChargeTaxTitle?.split(" ")[0];
                let s2 = ddd?.shippingChargeTaxTitle?.split(" ")[1];
                let shipTaxTitle = (ddd.shippingChargeTaxTitle2 = s1 + s2);

                setKeys(Object.keys(obj));
                setValues(Object.values(obj));

                let arr = [];
                Object.keys(obj).map((a, i) => {
                    Object.values(obj).map((b, j) => {
                        if (i === j) {
                            return arr.push({ tax: a, value: b });
                        }
                    });
                });

                let z = JSON.parse(JSON.stringify(d));

                z.map((a) => {
                    a.newHsn = a.hsnSac.toString() + "_" + a.taxBean.newTax;
                });

                let obj2 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj2[z[i].newHsn]) {
                        obj2[z[i].newHsn] += z[i].taxBean.disAmount;
                    } else {
                        obj2[z[i].newHsn] = z[i].taxBean.disAmount;
                    }
                }

                let obj3 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj3[z[i].newHsn]) {
                        obj3[z[i].newHsn] += z[i].disItemAmount;
                    } else {
                        obj3[z[i].newHsn] = z[i].disItemAmount;
                    }
                }

                setHsnKey(Object.keys(obj2));
                setHsnVal1(Object.values(obj2));
                setHsnVal2(Object.values(obj3));

                let t2 = ddd.totalAmount.toFixed(2).toString()?.split(".")[1];
                if (t2 > 49) {
                    ddd.totalAmount += 1;
                    let a = 100 - t2;
                    ddd.rounding = "+0." + a;
                } else {
                    ddd.rounding = "-0." + t2;
                }

                ddd.netTax = netTax;
                ddd.disTax = disTax;

                ddd.shipValue =
                    ddd.shippingCharges /
                    (1 + ddd.shippingChargeTaxRate * 0.01);
                let zx = (ddd.shipTaxValue =
                    ddd.shippingCharges - ddd.shipValue);

                arr.map((a) => {
                    if (a.tax === shipTaxTitle) {
                        a.value = a.value + zx;
                    }
                });

                ddd.taxDetail = arr;
                logSalesOrderHistory(res.responsePacket.orderNo).then((res) => {
                    if (res.errorCode === 0) {
                        const d = res.responsePacket;
                        setLogData(d);
                    } else {
                        toast(res.message);
                    }
                });

                let localDate = new Date(res.responsePacket.salesOrderDate)
                    .toISOString()
                    .replace(/T.*/, "")
                    .split("-")
                    .reverse()
                    .join("-");

                res.responsePacket.salesOrderDate = localDate;
                setBatchDetails(res.responsePacket?.items.reduce((acc, item) => acc.concat(item), []))
                setSalesOrderDetail(res.responsePacket);

                setOrgDetail(org);
                if (org?.beanAddress?.state === undefined) {
                    alert("logged In user's organization address not found ");
                }

                let gst12cust = res.responsePacket.customerGstNumber.substring(
                    0,
                    2
                );
                let gst12org = org.gstNumber.substring(0, 2);
                let customerAddress;
                res.responsePacket.customerAddresses.map((item) => {
                    if (item.addressType === "Billing") {
                        customerAddress = item.state;
                    }
                })
                if (gst12cust === gst12org) {
                    setTaxType("intra");
                } else {
                    if (customerAddress === orgState) {
                        setTaxType("intra");
                    } else {
                        setTaxType("inter");
                    }
                }

            } else {
                toast(res.message);
            }



        });

    };
    useEffect(() => {
        getAllSalesOrders();
        getSalesOrderDetails(id);
    }, [id]);

    useEffect(() => {
        getAllSalesOrders();
    }, [filterText])
    // useEffect(() => {
    //     if (batchDetails.length > 0) {
    //         let finalbatchdetails = batchDetails?.reduce((acc, item) => {
    //             const index = acc?.findIndex(obj => obj.itemTitle === item.itemTitle);
    //             if (index !== -1) {
    //                 acc[index] = {
    //                     ...acc[index], 
    //                     quantity: acc[index].quantity + item.quantity,
    //                     salesOrderNo: acc[index].salesOrderNo + `/${item.salesOrderNo}` 
    //                 };
    //             } else {
    //                 acc.push(item);
    //             }
    //             return acc; 
    //         }, []);
    //         setmultiBatch(finalbatchdetails);
    //     }
    // }, [batchDetails]);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: salesOrderDetail?.orderNo,
        // pageStyle: "print",
    });

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const filterOptions = [
        { value: "isInvoiced", label: "isInvoiced" },
        { value: "isPaid", label: "isPaid" },
        { value: "isPacked", label: "isPacked" },
        { value: "allOrders", label: "allOrders" },
    ];

    const handleFilter = (e) => {
        if (e.value === "isPaid") {
            var arr1 = rows.filter((data) => data.isPaid);
            setSalesOrdersList(arr1);
        }
        if (e.value === "isInvoiced") {
            var arr2 = rows.filter((data) => data.isInvoiced);
            setSalesOrdersList(arr2);
        }
        if (e.value === "isPacked") {
            var arr3 = rows.filter((data) => data.isPacked);
            setSalesOrdersList(arr3);
        }
        if (e.value === "allOrders") {
            var arr3 = rows.filter((data) => data.orderNo);
            setSalesOrdersList(arr3);
        }
    };
    const handlePrint1 = () => {
        // setPrintDiv(true);
        var doc = new jsPDF("p", "pt", "a3"); //potrait
        // var doc = new jspdf('l', 'pt', "a4");  // For landscape
        doc.html(document.getElementById("pdf"), {
            callback: function (doc) {
                doc.save(salesOrderDetail?.orderNo);
            },
        });
    };

    const pdfOptions = [
        { label: "All", value: "All" },
        { label: "Original", value: "Original" },
        { label: "Duplicate", value: "Duplicate" },
        { label: "Triplate", value: "Triplate" },
    ];



    const handleSalesOrderPick = (id) => {
        if (picklist.includes(id)) {
            setPickList((prev) => prev.filter(d => d != id))
        }
        else {
            setPickList((prev) => { return [...prev, id] })
        }
    }
    const handleMultipleSalesorder = async () => {
        let data = await multipleSalesOrder({ uuid: picklist });
        let finalbatchdetails = data?.responsePacket.reduce((acc, e) => acc.concat(e.items), [])?.reduce((acc, item) => {

            const { unit, quantity, Qty, salesOrderNo, itemTitle } = item;

            const index = acc.findIndex(obj => obj.itemTitle === itemTitle);

            if (index !== -1) {
                if (acc[index].Quantity?.[unit]) {
                    acc[index].Quantity[unit] += quantity;
                } else {
                    acc[index].Quantity[unit] = quantity;
                }

                acc[index].salesOrderNo = acc[index].salesOrderNo + `/${salesOrderNo}`;
            } else {
                acc.push({
                    ...item,
                    Quantity: { [unit]: quantity },
                    salesOrderNo: salesOrderNo,
                });
            }

            return acc;
        }, []);

        setmultiBatch(finalbatchdetails);
        setPickList([]);
        setPick(false);
    };



    return (
        <>
            <div
                className="list-column column d-print-none"
                style={{ width: "300px" }}
            >
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <Link to="/salesorders/new" className="newListBtn">
                            <AddIcon />
                            New
                        </Link>
                        <div className="input-group paginationSearchInput listSearch">
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="basic-addon1"
                                >
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input
                                autoComplete="off"
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                onChange={handleSearch}
                            />
                        </div>
                    </div>
                </div>

                <div
                    className="scroll-y fill body scrollbox list-body"
                >
                    <div className="table-responsive overflow-initial ">
                        <table
                            id="ember7912"
                            className="table zi-table ember-view header-fixed"
                        >
                            {salesOrdersList && (salesOrdersList.length > 0 ?
                                (<tbody>
                                    {salesOrdersList.map((d, i) => (
                                        <tr
                                            key={i}
                                            className={`listTr ${id === d.recordId
                                                ? "activeRecord"
                                                : ""
                                                }`}
                                        >
                                            <td>
                                                <Link
                                                    to={`/salesorders/${d.recordId}`}
                                                    className={`${id === d.recordId ? "text-primary" : "text-grey"}`}
                                                >
                                                    <span className="titleTr">
                                                        {d.customerTitle}
                                                    </span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.orderNo}</span>
                                                        <span>₹{" "}{d.totalAmount?.toFixed(2)}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        salesOrderListDetails &&
                                        salesOrderListDetails.recordsTotal >
                                        salesOrdersList.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllSalesOrders}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )}
                                </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                            )}
                        </table>
                    </div>
                </div>
            </div>
            <div className="column content-column" style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">

                    <h6 class="listTopHeading">
                        ( {salesOrderDetail?.orderNo} )
                    </h6>

                    <a
                        className="over-flow header-title text-uppercase"
                        style={{ fontSize: "x-large" }}
                    >
                        &nbsp;
                    </a>
                    <div className="btn-toolbar d-flex justify-content-end align-items-center">

                        <div className="btn-group mr-2 pr-0">
                            <button
                                className="tooltip-container ember-view btn btn-primary print-btn m-0"
                                onClick={handlePrint}
                            >
                                <LocalPrintshopOutlinedIcon />
                            </button>
                        </div>
                        {salesOrderDetail?.isShipped ? (
                            <></>
                        ) : (
                            <>
                                {props.superAdmin || salesOrderDetail?.isConfirmed || (props.urlList && props.urlList.has("/salesOrder/afterSalesOrderConfirm")) ? (
                                    <button
                                        className="tooltip-container ember-view btn btn-primary mr-2"
                                        onClick={() =>
                                            handleEdit(
                                                salesOrderDetail !== null ? salesOrderDetail.recordId : null
                                            )
                                        }
                                    >
                                        <EditIcon />
                                    </button>
                                ) : <></>}
                                {salesOrderDetail?.isConfirmed &&
                                    !salesOrderDetail?.isInvoiced ? (
                                    <button
                                        className="tooltip-container ember-view btn btn-primary m-0"
                                        onClick={() =>
                                            navigate(`/invoices/new`, {
                                                state: {
                                                    invoiceId:
                                                        salesOrderDetail.recordId,
                                                    invoiceOrder: true,
                                                },
                                            })
                                        }
                                        type="button"
                                    >
                                        <Tooltip title="Create Invoice">
                                            <ReceiptIcon />
                                        </Tooltip>
                                    </button>
                                ) : (
                                    <></>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <Tabs
                    selectedIndex={tabIndex}
                    onSelect={(index) => setTabIndex(index)}
                    className="upperTabs"
                >
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                        <Tab>Batch Details</Tab>
                    </TabList>
                    <TabPanel>
                        {salesOrderDetail &&
                            salesOrderDetail &&
                            orgDetail &&
                            orgDetail ? (
                            <ViewPdf
                                orderDetail={salesOrderDetail}
                                itemList={salesOrderDetail.items}
                                orgDetail={orgDetail}
                                taxType={taxType}
                                componentRef={componentRef}
                                pdfType={"sales"}
                                keys={keys}
                                values={values}
                                handlePrint={handlePrint}
                                hsnKey={hsnKey}
                                hsnVal1={hsnVal1}
                                hsnVal2={hsnVal2}
                            />
                        ) : (
                            <></>
                        )}
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length > 0 && (
                                    <tbody>
                                        {logData?.map((a, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td
                                                        style={{
                                                            verticalAlign:
                                                                "top",
                                                            width: "80px",
                                                        }}
                                                    >
                                                        {a?.transactionDate?.substring(
                                                            0,
                                                            10
                                                        )}
                                                        :&nbsp;&nbsp;
                                                        <br />
                                                        Time:
                                                        {a?.transactionDate
                                                            ?.split("T")[1]
                                                            .substring(0, 5)}
                                                    </td>

                                                    <td>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: a?.message
                                                                    .replaceAll(
                                                                        "\n",
                                                                        "<br />"
                                                                    )
                                                                    .replaceAll(
                                                                        "\t",
                                                                        "&nbsp;&nbsp;&nbsp;&nbsp;"
                                                                    ),
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox" ref={componentRef}>
                            <div
                                className='row4'
                                style={{
                                    border: '1px solid black',
                                    width: '100%',
                                }}
                            >
                            </div>
                            <div >
                                <table
                                    style={{
                                        width: '100%',
                                        tableLayout: 'fixed',
                                        clear: 'both',
                                    }}
                                    className='pcs-label'
                                    id='itemTable'
                                    cellSpacing={0}
                                    cellPadding={0}
                                    border='1px solid black'
                                >
                                    <thead>
                                        <tr>
                                            <td style={{ width: '10%' }}>S.No.</td>
                                            <td style={{ width: '100%', display: "flex", justifyContent: "space-between" }}><span style={{ marginLeft: "5px", width: "33%" }}>Item</span><span style={{ width: "33%" }}>SKU</span><span style={{ width: "33%" }}>Total Qty</span></td>
                                        </tr>

                                    </thead>
                                    <tbody >
                                        {(multiBatch?.length > 0 ? multiBatch : batchDetails)?.map((item, index) => {
                                            return (
                                                <tr style={{ marginLeft: "8px" }} key={index}>
                                                    <td><div style={{ width: "100%", marginLeft: "20px" }}>{index + 1}</div></td>
                                                    <td>
                                                        <div style={{ marginLeft: "5px", marginRight: "5px", display: "flex", justifyContent: "space-between" }}><span style={{ width: "33%" }}>{item.itemTitle}{item?.salesOrderNo}</span><span style={{ width: "33%" }}>{item?.sku}</span><span style={{ width: "33%" }}>{item?.Quantity ? Object.entries(item?.Quantity).map(([key, value]) => {
                                                            return (
                                                                <div key={key}>
                                                                   {value}: <strong>{key}</strong> 
                                                                </div>
                                                            );
                                                        }) : <div >
                                                           {item.quantity}: <strong>{item.unit}</strong> 
                                                        </div>}</span></div>
                                                        <table style={{
                                                            width: '100%',
                                                            tableLayout: 'fixed',
                                                            clear: 'both',
                                                            marginTop: "10px"
                                                        }}
                                                            className='pcs-label'
                                                            id='itemTable'
                                                            cellSpacing={0}
                                                            cellPadding={0}
                                                            border='1px solid black'>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: "17%" }}>Batch No</th>
                                                                    <th style={{ width: "12%" }}>Batch Qty</th>
                                                                    <th style={{ width: "12%" }}>Mfg Date</th>
                                                                    <th style={{ width: "12%" }}>Exp Date</th>
                                                                    <th style={{ width: "10%" }}>Store</th>
                                                                    <th style={{ width: "7%" }}>Rack</th>
                                                                    <th style={{ width: "7%" }}>Cell</th>
                                                                    <th style={{ width: "7%" }}>Pallete</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody style={{ fontWeight: "400" }}>
                                                                <>
                                                                    {item?.beanInvoiceBatchesList?.map((e) => {
                                                                        return <tr key={index}>
                                                                            <td>{e?.batchNumber}</td>
                                                                            <td>{e?.batchQuantity}</td>
                                                                            <td>{e?.batchManufacturingDate}</td>
                                                                            <td>{e?.batchExpiredDate}</td>
                                                                            <td>{e?.storeTitle}</td>
                                                                            <td>{e?.rackTitle}</td>
                                                                            <td>{e?.cellTitle}</td>
                                                                            <td>{e?.palletTitle}</td>
                                                                        </tr>
                                                                    })}

                                                                </>

                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </TabPanel>

                </Tabs>
                <br />
            </div>
            <Toaster />
            <Modal show={pick} onHide={() => setPick(false)} size="lg">
                <Modal.Header>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <h1>Select Sales Order</h1> <Button
                            variant="primary"
                            onClick={handleMultipleSalesorder}
                        >
                            Submit
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div
                        className="scroll-y fill body scrollbox list-body"
                    >
                        <div className="table-responsive overflow-initial ">
                            <table
                                id="ember7912"
                                className="table zi-table ember-view header-fixed"
                            >
                                {salesOrdersList && (salesOrdersList.length > 0 ?
                                    (<tbody>
                                        {salesOrdersList.map((d, i) => (
                                            <tr
                                                key={i}
                                                className={`listTr ${picklist.includes(d.recordId)
                                                    ? "activeRecord"
                                                    : ""
                                                    }`}
                                                onClick={() => handleSalesOrderPick(d?.recordId)}
                                            >
                                                <td>
                                                    <span className="titleTr">
                                                        {d.customerTitle}
                                                    </span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.orderNo}</span>
                                                        <span>₹{" "}{d.totalAmount?.toFixed(2)}</span>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                        {
                                            salesOrderListDetails &&
                                            salesOrderListDetails.recordsTotal >
                                            salesOrdersList.length && (
                                                <div className="pt-3">
                                                    <button
                                                        className="btn mx-auto newListBtn"
                                                        onClick={getAllSalesOrders}
                                                    >
                                                        Load More
                                                    </button>
                                                </div>

                                            )}
                                    </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                                )}
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SalesView;
